module.exports = __webpack_public_path__ + "7653205b9d3baeb7ab3c3c9ac44e715d.svg";